import React, { ButtonHTMLAttributes } from 'react';

import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  containerStyle?: object;
  bgcolor?: string;
  animated?: boolean;
  delay?: number;
};

const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  containerStyle = {},
  bgcolor = '#bc4143',
  animated = false,
  delay = 0,
  ...rest
}) => {
  return (
    <Container
      $bgcolor={bgcolor}
      $animated={animated || undefined}
      $delay={delay}
      as="button"
      type="button"
      style={containerStyle}
      {...rest}
    >
      {loading ? 'Aguarde' : children}
    </Container>
  );
};

export default Button;
